import type { ValueOf } from '@shared/types/utilities';

export const entities = {
  dashboard: 'dashboard',
  user: 'user',
  member: 'member',
  student: 'student',
  organizationSettings: 'organizationsettings',
  eWalletAccount: 'ewalletaccount',
  bankAccount: 'bankaccount',
  favouriteProgram: 'favouriteprogram',
  field: 'field',
  program: 'program',
  programDocument: 'programdocument',
  programDocumentTemplate: 'programdocumenttemplate',
  section: 'section',
  submission: 'submission',
  submissionDocument: 'submissiondocument',
  submissionFlightInfo: 'submissionflightinfo',
  product: 'product',
  invoice: 'invoice',
  payment: 'payment',
  meeting: 'meeting',
  interviewer: 'interviewer',
  lead: 'lead',
  task: 'task',
  taskStatus: 'taskstatus',
  stage: 'stage',
  rule: 'rule',
  participantRuleProgress: 'participantruleprogress',
  participantStageProgress: 'participantstageprogress',
  reminder: 'reminder',
  reminderTemplate: 'remindertemplate',
  reminderLog: 'reminderlog',
  placementHostCompany: 'placementhostcompany',
  placementSkill: 'placementskill',
  placement: 'placement',
  placementApplication: 'placementapplication',
  placementSponsor: 'placementsponsor',
  assignedPlacement: 'assignedplacement',
  meetingNote: 'meetingnote',
  meetingTemplate: 'meetingtemplate',
  leadStatus: 'leadstatus',
  leadReferal: 'leadreferal',
  leadConversion: 'leadconversion',
  programDocumentanswer: 'programdocumentanswer',

  invitation: 'invitation',
  label: 'label',
  media: 'media',
  organization: 'organization',
  integration: 'integration',
  address: 'address',
  answer: 'answer',
  productVariant: 'productvariant',
  lineItem: 'lineitem',
  receipt: 'receipt',
  taskComment: 'taskcomment',
  calendlyToken: 'calendlytoken',
  calendlyWebhookPayload: 'calendlywebhookpayload',
  programTemplate: 'programtemplate',
  templateSection: 'templatesection',
  templateSectionField: 'templatesectionfield',
  stageTemplate: 'stagetemplate',
  ruleTemplate: 'ruletemplate',
  stripeCustomer: 'stripecustomer',
  stripeSubscription: 'stripesubscription',
  stripeToken: 'stripetoken',
  twilioConnectedAccount: 'twilioconnectedaccount',
  twilioService: 'twilioservice',
  defaultRole: 'defaultrole',
  role: 'role',
  calendlyWebhook: 'calendlywebhook',
  calendlyTrackedEvent: 'calendlytrackedevent',
  calendlyEventType: 'calendlyeventtype',
  lockedSection: 'lockedsection',
  emergencyContactInfo: 'emergencycontactinfo',
  contactInfo: 'contactinfo',
  memberAddress: 'memberaddress',
  organizationAddress: 'organizationaddress',
  organizationContactInfo: 'organizationcontactinfo',
  subscriptionPlan: 'subscriptionplan',
  paymentMethod: 'paymentmethod',
  organizationsubscription: 'organizationsubscription',
  memberBankAccount: 'memberbankaccount',

  memberDocument: 'memberdocument',
  studentNote: 'studentnote',
  leadNote: 'leadnote',
  view: 'view',
  taskWorkspace: 'taskworkspace',
  taskWorkspaceMember: 'taskworkspacemember',
  export: 'exporthistory',
  university: 'university',
  import: 'importhistory',
  universityStatus: 'universitystatus',
  activitylog: 'activitylog',
  submissionVisaInterview: 'submissionvisainterview',
  announcement: 'announcement',
  knowledgeDocument: 'knowledgedocument',
  commentAutomation: 'commentautomation',
  commentAutomationRun: 'commentautomationrun',
  staticFilter: 'staticfilter',
  sectionComment: 'sectioncomment',
  submissionDate: 'submissiondate',
  organizationBranding: 'organizationbranding',
  submissionVisaInterviewNote: 'submissionvisainterviewnote',
  submissionVisaResult: 'submissionvisaresult',
} as const;

export type TEntity = ValueOf<typeof entities>;
